






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import {colors} from '@/config';
import vue from 'vue';

More(Highcharts);

@Component({components: {Chart}})
export default class CashflowV2 extends Vue {
  @Prop() readonly cashflow!: any;
  @Prop() readonly balance!: any;

  chartOptions: any = {
    chart: {
      type: 'waterfall',
      // plotBackgroundColor: colors.White,
      backgroundColor: 'transparent',
      spacingRight: 20,
      // height: '80%',
    },
    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    yAxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          fontSize: '1rem',
          color: colors.DarkGrey,
        },
        formatter() {
          return (vue as any).options.filters.KR((this as any).value);
        },
      },

      plotLines: [{
        color: colors.Black,
        width: 2,
        value: 0,
        zIndex: 2,
      }],

      tickPixelInterval: 150,
      gridLineColor: colors.LightGrey,
    },

    xAxis: {
      type: 'category',
      labels: {
        style: {
          fontSize: '1rem',
          color: colors.Black,
          textOverflow: 'none',
          whiteSpace: 'normal',
        },
      },
      plotLines: [{
          color: colors.Light,
          value: 6.5,
          width: 2,
          zIndex: 2,

          label: {
            text: 'analyscenter.se',
            verticalAlign: 'bottom',
            textAlign: 'right',
            y: -10,
            style: {
              fontSize: '0.875rem',
              color: colors.LightGrey,
            },
          },
        },

        {
          color: colors.LightGrey,
          value: 0.5,
          width: 1,
        },
        {
          color: colors.LightGrey,
          value: 5.5,
          width: 1,
        },
      ],
      plotBands: [{
        color: colors.Light,
        from: -0.5,
        to: 0.5,
      },
        {
          color: colors.Light,
          from: 5.5,
          to: 6.5,
        },
      ],
    },

    plotOptions: {
      series: {
        borderColor: colors.Black,
        dashStyle: 'shortdash',
      },
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      headerFormat: '',
      formatter() {
        const me = this as any;
        const v = (vue as any).options.filters.TKR(me.point.y);
        const z = (vue as any).options.filters.TKR(me.point.y - me.point.JPrev);
        const x = (vue as any).options.filters.TKR(me.point.J);
        if (me.key === Vue.prototype.$t('UB')) {
          return `${me.point.subname}: <b>${v}</b><br/>${Vue.prototype.$t('Årets kassaflöde')}: <b>${z}</b>`;
        } else {
          return `${me.point.subname}: <b>${v}</b>`;
        }
      },
      // pointFormat: '{point.subname}:  <b>{point.y:,.0f} tkr</b>',
      style: {
        fontSize: '1.25rem',
        color: colors.black,
      },
      backgroundColor: colors.Light,
    },

    series: [],
  };

  @Watch('balance', {immediate: true, deep: true})
  onBalanceChanged() {
    this.onDataChanged();
  }

  @Watch('cashflow', {immediate: true, deep: true})
  onCashflowChanged() {
    this.onDataChanged();
  }

  onDataChanged() {
    if (this.cashflow === undefined) {
      return;
    }
    if (this.cashflow.sheets === undefined) {
      return;
    }
    if (this.cashflow.sheets.length === 0) {
      return;
    }
    if (this.balance === undefined) {
      return;
    }
    if (this.balance.sheets === undefined) {
      return;
    }
    if (this.balance.sheets.length === 0) {
      return;
    }

    const cf = this.cashflow.sheets[0];
    const br = this.balance.sheets[0];
    const brPrev = this.balance.sheets[1];
    this.chartOptions.series = [{
      upColor: colors.Positive,
      color: colors.Negative,
      data: [{
        name: Vue.prototype.$t('IB'),
        subname: Vue.prototype.$t('IB Kassa & Bank'),
        color: colors.LightGrey,
        y: brPrev.J, // Värdet kommer från BR "Kassa & Bank" föregående år
      },
        {
          name: Vue.prototype.$t('Operativt kassaflöde'),
          subname: Vue.prototype.$t('Operativt kassaflöde'),
          y: cf.OperatingCashflow,
        },
        {
          name: Vue.prototype.$t('Förändring rörelsekapital'),
          subname: Vue.prototype.$t('Förändring rörelsekapital'),
          y: cf.WorkingCaptialCashflow,
        },
        {
          name: Vue.prototype.$t('Investeringar'),
          subname: Vue.prototype.$t('Investeringar'),
          y: cf.InvestmentsCashflow,
        },
        {
          name: Vue.prototype.$t('Förändring räntebärande skulder'),
          subname: Vue.prototype.$t('Förändring räntebärande skulder'),
          y: cf.InterestLiabilitiesDelta,
        },
        {
          name: Vue.prototype.$t('Ägarkapital'),
          subname: Vue.prototype.$t('Ägarkapital'),
          y: cf.EquityWithoutNetProfitDelta + cf.SubscribedCapitalUnpaidDelta,
        },
        {
          name: Vue.prototype.$t('UB'),
          subname: Vue.prototype.$t('UB Kassa & Bank'),
          isSum: true, // Värdet bör vara detsamma som BR "Kassa & Bank" innevarande år
          color: colors.LightGrey,
          JPrev: brPrev.J,
          J: br.J,
        },
      ],

      pointPadding: 0,
    }];
    // this.chartOptions.series = [{
    //   name: 'Population',
    //   data: [
    //     {
    //       name: 'ÅRETS KASSAFLÖDE',
    //       y: cf.CashFlow,
    //       color: cf.CashFlow >= 0 ? colors.Green : colors.Red,
    //     },
    //     {
    //       name: 'Operativt kassaflöde',
    //       y: cf.OperatingCashflow,
    //     },
    //     {
    //       name: 'Förändring Rörelsekapital',
    //       y: cf.WorkingCaptialCashflow,
    //     },
    //     {
    //       name: 'Investeringar',
    //       y: cf.InvestmentsCashflow,
    //     },
    //     {
    //       name: 'Finansiering',
    //       y: cf.FinancingCashflow,
    //     },
    //   ],
    //   color: colors.Primary,
    //   negativeColor: colors.Secondary,
    //   borderWidth: 1,
    //   borderColor: colors.DarkGrey,
    //   dataLabels: {
    //     enabled: false,
    //   },
    // }];
  }
}


